import { useEffect } from 'react';
import { useGlobalSettings } from '@/hooks';

/**
 * Component to dynamically update the favicon based on settings
 * This component should be included in the main App component to ensure favicon is updated globally
 */
const FaviconUpdater = () => {
  const { settings: globalSettings } = useGlobalSettings();

  useEffect(() => {
    // Get the favicon link element
    let faviconLink = document.querySelector("link[rel~='icon']");
    
    // If no favicon link exists, create one
    if (!faviconLink) {
      faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      document.head.appendChild(faviconLink);
    }

    // Update favicon URL if available in settings
    if (globalSettings?.home_page_general_favicon_logo) {
      faviconLink.href = globalSettings.home_page_general_favicon_logo;
    }
  }, [globalSettings]);

  // This component doesn't render anything visible
  return null;
};

export default FaviconUpdater;
